/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalRecommenderAPI
 * @hideconstructor
 *
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/InternalRecommenderAPI',
	'../../../visualizations/recommender/VisRecommenderUtils'
], (APIFactory, InternalRecommenderAPI, VisRecommenderUtils) => {
	class InternalRecommender {

		constructor(options) {
			this._api = APIFactory.createAPI(this, [InternalRecommenderAPI]);
			this.features = options.features;
		}

		getAPI() {
			return this._api;
		}

		getChartTypeList() {
			let chartTypes = [];
			//TODO: add dependency on VisDefinitions
			try {
				let visDefinitions = this.features['VisDefinitions'].getList();
				chartTypes = VisRecommenderUtils.buildChartTypes(visDefinitions);
			} catch (err) {
				this.features['Logger'].error(err);
			}
			return chartTypes;
		}

	}
	return InternalRecommender;
});
